<template>
    <div class="container">
        <div class="row">
            <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                Featured Shows
            </div>
            <div v-for="(show, index) in showsData" :key="index"
                class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-2 px-3 show-card"
                :style="{ transitionDelay: `${index * 0.12}s` }">

                <div class="position-relative">
                    <img :src="`${$API_ASSETS}${show.banner_image.id}?width=800&quality=80`" class="img-fluid py-2" />
                    <img v-if="show.family_friendly" :src="require('@/assets/familyFriendly.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-150%,0%);" />
                    <img v-if="show.pay_what_you_can" :src="require('@/assets/pay-what-you-can.png')"
                        class="position-absolute" style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                </div>

                <div class="text-start">
                    <span class="fs-2 text-uppercase oswald-bold">{{ show.name }}</span>
                    <span class="fs-5 d-block oswald-bold">{{ show.date_text }}</span>
                    <p class="m-0 py-1">{{ show.description }}</p>
                    <p class="m-0 text-uppercase py-2">
                        <a :href="getShowLink(show)" class="cardlink">{{ getButtonText(show)
                            }} <i class="fa-solid fa-arrow-right"></i></a>
                    </p>
                </div>
            </div>
            <!-- Featured Workshops Section -->
            <template v-if="featuredWorkshops.length > 0">
                <div class="col-12">
                    <div class="text-center fs-1 pt-5 pb-4 text-uppercase oswald-bold">
                        Upcoming Workshops
                    </div>
                </div>
                <div v-for="(workshop, index) in featuredWorkshops" :key="'fw-' + workshop.id"
                    class="col-md-4 d-flex flex-column align-items-center justify-content-start pb-2 px-3 show-card"
                    :style="{ transitionDelay: `${index * 0.12}s`, cursor: 'pointer' }"
                    @click="$router.push('/Classes')">
                    <div class="position-relative">
                        <img v-if="workshop.banner_image && workshop.banner_image.id"
                            :src="`${$API_ASSETS}${workshop.banner_image.id}?width=800&quality=80`"
                            class="img-fluid py-2" />
                        <img v-if="workshop.core_req" :src="require('@/assets/CoreRequired.png')" class="position-absolute"
                            :style="{ bottom: '-15%', width: '25%', transform: workshop.is_free ? 'translate(-200%,0%)' : 'translate(-100%,0%)' }" />
                        <img v-if="workshop.is_free" :src="require('@/assets/free.png')" class="position-absolute"
                            style="bottom: -15%; width: 25%; transform: translate(-100%,0%);" />
                    </div>
                    <div class="text-start" style="position: relative; z-index: 3;">
                        <span class="fs-2 text-uppercase oswald-bold">{{ workshop.name }}</span>
                        <span class="fs-5 d-block oswald-bold">{{ workshop.meets_text }}</span>
                        <p class="m-0 py-1">{{ workshop.long_desc || '' }}</p>
                        <p class="m-0 text-uppercase py-2">
                            <a :href="workshop.link" class="cardlink" @click.stop>Register <i class="fa-solid fa-arrow-right"></i></a>
                        </p>
                    </div>
                </div>
            </template>

            <div class="col-12 d-flex align-items-center justify-content-center pt-5 pb-5">
                <a :href="`${$TICKETS_URL}`">
                    <div class="btn px-3 text-uppercase dark-btn" type="button">All shows & Events</div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
    name: 'UpcomingShows',
    props: {
        showsData: {
            type: Array,
            default: () => []
        },
        featuredWorkshops: {
            type: Array,
            default: () => []
        }
    },
    setup() {
        return {
            router: useRouter()
        };
    },
    methods: {
        getShowLink(show) {
            if (show.name && show.name.toLowerCase().includes('up all night jam')) {
                return '/jam';
            }
            if (show.name && show.name.toLowerCase() === 'the cut') {
                return 'https://atlasimprov.com/thecut/';
            }
            return show.fw_link || '#';
        },
        getButtonText(show) {
            if (show.name && show.name.toLowerCase().includes('up all night jam')) {
                return 'Learn More';
            }
            if (show.name && show.name.toLowerCase() === 'the cut') {
                return 'Learn More';
            }
            return show.learn_more ? 'Learn More' : 'Buy Tickets';
        },
        observeCards() {
            if (this._cardObserver) this._cardObserver.disconnect();
            const cards = this.$el.querySelectorAll('.show-card');
            this._cardObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('show-card--visible');
                        this._cardObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });
            cards.forEach(card => this._cardObserver.observe(card));
        }
    },
    mounted() {
        this.observeCards();
    },
    beforeUnmount() {
        if (this._cardObserver) this._cardObserver.disconnect();
    }
};
</script>

<style scoped>
.show-card {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.5s ease, transform 0.5s ease;
}
.show-card--visible {
    opacity: 1;
    transform: translateY(0);
}

/* Keep the card text above the badges, which dip down (bottom: -15%) into this area */
.show-card .text-start {
    position: relative;
    z-index: 2;
}
</style>
